import {
  userLogin,
  getUserManage
} from "../../api/api.js"
import {
  getTokenInfo,
  setTokenInfo,
  removeTokenInfo,
  setUserInfo,
  getUserInfo,
  removeUserInfo,
  setMenu,
  removeMenu,
  getExpire,
  setExpire,
  removeExpire
} from '../../utils/auth'
import {
  hex_md5
} from '@/utils/md5.js'
import Cookies from 'js-cookie'
import router from '../../router'
import MenuUtils from "../../utils/menuUtils.js"
import asyncMenu from "../../router/asyncMenu.js"
import menulistjson from "../../data/menulistjson.js"
import avatar from "@/assets/images/avatar2.jpg"
import { isLocal } from "@/settings.js"

const _tokeninfo = getTokenInfo()
const _userinfo = getUserInfo()
const _expire = getExpire()
const getDefaultState = () => {
  return {
    token: !_tokeninfo ? '' : _tokeninfo.token,
    tokeninfo: _tokeninfo,
    tokenExpires: !_expire ? 86400 : _expire,
    userName: !_userinfo ? '' : _userinfo.name,
    userRole: !_userinfo ? '' : _userinfo.role,
    userInfo: _userinfo,
    avatar: avatar,
    roleLimit: [0, 1, 2]
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_TOKENINFO: (state, info) => {
    state.tokenInfo = info
  },
  SET_TOKENEXPIRES: (state, expires) => {
    state.tokenExpires = expires
  },
  SET_NAME: (state, name) => {
    state.userName = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USERINFO: (state, info) => {
    state.userInfo = info
    state.userName = info.name
    state.userRole = info.role
  }
}

const actions = {
  // 用户登录
  login({
    dispatch
  }, userInfo) {
    if (isLocal) {
      return new Promise(async (resolve, reject) => {
        await dispatch('loginLocal')
        resolve()
      })
    } else {
      // 登录逻辑
      const {
        account,
        password,
      } = userInfo
      const pwd = hex_md5(password).toUpperCase()
      return new Promise((resolve, reject) => {
        userLogin({
          query: {
            action: 'DoLogin'
          },
          body: {
            username: account.trim(),
            password: pwd
          }
        }).then(async response => {
          if (response.status == 0) {
            const {
              data
            } = response
            await dispatch('tokenInfo', JSON.stringify(data))
            await dispatch('getUserInfo')
            // 使用本地登录数据
            await dispatch('getMenuLocal')
            resolve()
          } else {
            reject()
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  DDlogin({
    dispatch
  }, DDInfo) {
    // 登录逻辑
    const {
      code,
      state,
    } = DDInfo
    return new Promise((resolve, reject) => {
      userLogin({
        query: {
          action: 'LoginByQRcode'
        },
        body: {
          code: code,
          state: state
        }
      }).then(async response => {
        if (response.status == 0) {
          const {
            data
          } = response
          await dispatch('tokenInfo', JSON.stringify(data))
          await dispatch('getUserInfo')
          // 使用本地登录数据
          await dispatch('getMenuLocal')
          resolve()
        } else {
          reject()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  DDloginByDingApp({
    dispatch
  }, DDCode) {
    // 登录逻辑
    const {
      code
    } = DDCode
    return new Promise((resolve, reject) => {
      userLogin({
        query: {
          action: 'LoginByDingApp'
        },
        body: {
          code: code
        }
      }).then(async response => {
        if (response.status == 0) {
          const {
            data
          } = response
          await dispatch('tokenInfo', JSON.stringify(data))
          await dispatch('getUserInfo')
          // 使用本地登录数据
          await dispatch('getMenuLocal')
          resolve()
        } else {
          reject()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 设置保存token信息
  tokenInfo({ commit, dispatch }, info) {
    return new Promise(async resolve => {
      const _info = JSON.parse(info)
      Cookies.remove('WOS-VERIFYLIMIT')
      setTokenInfo(info)
      commit('SET_TOKENINFO', _info)
      await dispatch('refreshExpire', _info.expire_time)
      resolve()
    })
  },
  // 获取用户信息
  getUserInfo({ commit }, info) {
    return new Promise((resolve, reject) => {
      let params = {
        query: {
          action: 'GetUserInfo'
        },
        body: {}
      }
      if (info) {
        params.body['phone'] = info.phone
      }
      getUserManage(params).then(response => {
        const {
          data
        } = response
        if (response) {
          commit('SET_USERINFO', data)
          setUserInfo(JSON.stringify(data))
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 刷新令牌
  setNewTokenInfo({ dispatch }, info) {
    dispatch('tokenInfo', JSON.stringify(info))
  },

  // 退出登录
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      removeTokenInfo() // 移除token信息
      removeUserInfo() //移除用户信息
      removeMenu()
      removeExpire()
      commit('RESET_STATE')
      resolve()
    })
  },
  refreshExpire({ commit }, expire) {
    return new Promise((resolve, reject) => {
      const _d = new Date()
      const _t = _d.getTime()
      const _ts = Math.floor(_t / 1000) + expire
      commit('SET_TOKENEXPIRES', _ts)
      setExpire(_ts)
      resolve()
    })
  },

  // 本地登录
  loginLocal({ dispatch, commit }) {
    return new Promise(async (resolve, reject) => {
      const content = {
        token: 'local-login-token',
        expire_time: Math.floor(new Date().getTime() / 1000) + 18000,
        type: 'local',
        refresh_token: 'local-Token',
        token_type: 'Kayi'
      }
      commit('SET_TOKENINFO', content)
      setTokenInfo(JSON.stringify(content))
      await dispatch('getInfoLocal')
      await dispatch('getMenuLocal')
      resolve()
    })
  },
  getInfoLocal({
    commit
  }) {
    return new Promise((resolve, reject) => {
      const content = {
        userName: 'local',
        id: 'local',
        role: 0
      }
      commit('SET_NAME', content.userName)
      const info = JSON.stringify(content)
      setUserInfo(info)
      resolve()
    })
  },
  getMenuLocal({
    commit
  }) {
    return new Promise((resolve, reject) => {
      //遍历更新菜单格式
      let menuData = []
      menulistjson(menuData)
      if (menuData != null) {
        // 遍历添加本地，菜单隐藏路由配置
        menuData = menuData.map((item) => {
          const asyncMenuIdx = asyncMenu.findIndex((value) => value.path == item.path)
          if (asyncMenuIdx >= 0) {
            const _child = asyncMenu[asyncMenuIdx].children
            asyncMenu.splice(asyncMenuIdx, 1);
            item.children = item.children.concat(_child)
          }
          return item
        })
        menuData = menuData.concat(asyncMenu)

        menuData = JSON.stringify(menuData).toLowerCase() //所有的key转换成小写
        setMenu(menuData)
      }
      router.options.routes = []
      let routes = []
      if (menuData.length > 0) {
        MenuUtils(routes, menuData)
        router.options.routes = Object.assign(
          router.options.routes,
          routes
        )
        router.addRoutes(routes)
      }
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/modules/web/store/modules/user.js